import React, { useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { useMutation, useQueryClient } from 'react-query'
import { CurrentCompanyContext } from '../../App.js'

import { Container } from '../layout/AppLayout.js';
import Row from 'react-bootstrap/Row';
import MaintanceForm from './MaintanceForm.js';
import { isAllowed } from '../shared/FeatureChecker.js';
import { CurrentUserContext } from '../../App.js';

import { useNotifications } from '../shared/Notifications.js'
import { useMutationClient } from '../shared/hooks.js'
import Header from "../shared/Header.js"

export default function MaintanceNewPage() {
  const queryClient = useQueryClient()
  const currentCompany = useContext(CurrentCompanyContext)
  const mutationClient = useMutationClient()
  const navigate = useNavigate()
  const notifications = useNotifications()
  const params = useParams()
  const currentUser = useContext(CurrentUserContext)


  useEffect(() => {
    if(currentUser){
      const allowed= isAllowed({user: currentUser,feature: "CREATE_REPORTS"})
      if (!allowed){
        navigate('/error?error=403')
      }
    }

  },[currentUser])

  const mutation = useMutation(data => mutationClient.post(`devicereport/${params.SensorId}`, { ...data, company_id: currentCompany && currentCompany.id }), {
    onSuccess: (data, variables, context) => {
      if( data.status === 200 ){
        notifications.success('Reporte de mantenimiento creado correctamente')
        navigate(`/sensors/${params.SensorId}/maintance`)
      }
    },
    onError: () => {
      notifications.danger('Ha ocurrido un error al crear el reporte')
    }
  })

  return (
    <Container>
      <Row>
        <Header title="Nuevo informe de mantenimiento" items={[
          { label: "Listado de dispositivos", to: "/sensors" },
            { label: "Detalle de dispostivo", to: `/sensors/${params.SensorId}` },
            { label: "Listado de mantenimientos", to: `/sensors/${params.SensorId}/maintance`},
            { label: "Nuevo mantenimiento"}
        ]} />
      </Row>

      <Row className="mb-4">
        <div className="col-12 col-md-10 col-lg-8 col-xl-6 mb-4">
          <div className="card mb-3 shadow-sm">
            <div className="card-header">Crear informe de mantenimiento</div>
            <div className="card-body">
              <MaintanceForm
                sensor={{}}
                save={data => mutation.mutate(data)}
                isLoading={mutation.isLoading}
              />
            </div>
          </div>
        </div>
      </Row>
    </Container>
  )
}